import React from 'react';

/* Small circular progress ring (SVG). Shared by the sidebar context section. */
const ProgressRing = ({ value, color }) => {
  const r = 28;
  const c = 2 * Math.PI * r;
  const off = c - (value / 100) * c;
  return (
    <div className="nano-ring">
      <svg width="66" height="66">
        <circle cx="33" cy="33" r={r} stroke="var(--n-border)" strokeWidth="6" fill="none" />
        <circle cx="33" cy="33" r={r} stroke={color} strokeWidth="6" fill="none"
          strokeDasharray={c} strokeDashoffset={off} strokeLinecap="round" />
      </svg>
      <div className="nano-ring-val">{value}%</div>
    </div>
  );
};

export default ProgressRing;
